import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { FormattedMessage } from 'react-intl';

import { IconButton } from '@bibliocommons/base-buttons';
import { Error as ErrorIcon } from '@bibliocommons/base-icons';
import ScreenReaderMessage from '@bibliocommons/base-screen-reader-message';

import Popover from 'app/components/shared/Popover';

import './LocationAlert.scss';

export default function LocationStatus({ location }) {
  const alertHtml = location.get('hoursNote');
  if (!alertHtml) {
    return null;
  }

  function renderPopoverContent() {
    /* eslint-disable react/no-danger */
    return (
      <>
        {/* eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex */}
        <p className="popover-heading" tabIndex={0}>
          <FormattedMessage id="location_alert"></FormattedMessage>
        </p>
        <p className="popover-content" dangerouslySetInnerHTML={{ __html: alertHtml }}></p>
      </>
    );
  }

  return (
    <div className="cp-location-alert">
      <Popover dataKey="location-alert-popover" renderContent={renderPopoverContent} rightAligned>
        <IconButton className="alert-button" dataKey="alert-button">
          <ErrorIcon />
          <ScreenReaderMessage>
            <FormattedMessage id="sr_location_alert" values={{ locationName: location.get('name') }} />
          </ScreenReaderMessage>
        </IconButton>
      </Popover>
    </div>
  );
}

LocationStatus.propTypes = {
  location: ImmutablePropTypes.map.isRequired
};
